/**
 * GENERATED font data — do not hand-edit.
 *
 * Maps each font family to its bundled base64 TTF module(s), lifted verbatim
 * from the former `configureUnicodeFontIfAvailable` switch in pdf-document.ts
 * (see the golden parity test). Pure data: every `load` is a lazy dynamic
 * import so a font module is only fetched when actually used. Behaviour lives
 * in ./font-registry.
 */

export type FontWeight = "normal" | "bold";

export interface FontSource {
  /** Path of the bundled base64 TTF module, used for dedup + golden parity. */
  modulePath: string;
  /** Lazily imports the bundled module and returns its base64 TTF content. */
  load: () => Promise<string>;
  /** Internal fonts (e.g. the signature font) are embeddable but not user-selectable. */
  selectable?: boolean;
}

export const fontRegistry: Record<string, Partial<Record<FontWeight, FontSource>>> = {
  "AdobeHandwriting-Ernie": {
    normal: { modulePath: "./AdobeHandwriting-Ernie", load: () => import("./AdobeHandwriting-Ernie").then((module) => module.signatureFieldTypeFontContent), selectable: false },
  },
  "American Typewriter": {
    normal: { modulePath: "./American-Typewriter-normal-normal", load: () => import("./American-Typewriter-normal-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./American-Typewriter-normal-normal", load: () => import("./American-Typewriter-normal-normal").then((module) => module.fontContent) },
  },
  "Andale Mono": {
    normal: { modulePath: "./Andale-Mono-normal-normal", load: () => import("./Andale-Mono-normal-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Andale-Mono-normal-normal", load: () => import("./Andale-Mono-normal-normal").then((module) => module.fontContent) },
  },
  "Arial": {
    normal: { modulePath: "./Arial-normal-normal", load: () => import("./Arial-normal-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Arial-normal-bold", load: () => import("./Arial-normal-bold").then((module) => module.fontContent) },
  },
  "Arial Black": {
    normal: { modulePath: "./ArialBlack-normal-normal", load: () => import("./ArialBlack-normal-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./ArialBlack-normal-bold", load: () => import("./ArialBlack-normal-bold").then((module) => module.fontContent) },
  },
  "Arial Narrow": {
    normal: { modulePath: "./Arial-Narrow-normal", load: () => import("./Arial-Narrow-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Arial-Narrow-normal", load: () => import("./Arial-Narrow-normal").then((module) => module.fontContent) },
  },
  "Arial Rounded MT Bold": {
    normal: { modulePath: "./ArialRoundedMTBold-bold", load: () => import("./ArialRoundedMTBold-bold").then((module) => module.fontContent) },
    bold: { modulePath: "./ArialRoundedMTBold-bold", load: () => import("./ArialRoundedMTBold-bold").then((module) => module.fontContent) },
  },
  "Arial Unicode MS": {
    normal: { modulePath: "./ArialUnicodeMS-normal-normal", load: () => import("./ArialUnicodeMS-normal-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./ArialUnicodeMS-normal-bold", load: () => import("./ArialUnicodeMS-normal-bold").then((module) => module.fontContent) },
  },
  "Avenir": {
    normal: { modulePath: "./Avenir-normal-normal", load: () => import("./Avenir-normal-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Avenir-normal-bold", load: () => import("./Avenir-normal-bold").then((module) => module.fontContent) },
  },
  "Avenir Next": {
    normal: { modulePath: "./Avenir-Next-Regular-normal", load: () => import("./Avenir-Next-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Avenir-Next-Regular-normal", load: () => import("./Avenir-Next-Regular-normal").then((module) => module.fontContent) },
  },
  "Avenir Next Condensed": {
    normal: { modulePath: "./AvenirNextCondensed-Regular-normal", load: () => import("./AvenirNextCondensed-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./AvenirNextCondensed-Regular-normal", load: () => import("./AvenirNextCondensed-Regular-normal").then((module) => module.fontContent) },
  },
  "Bahnschrift": {
    normal: { modulePath: "./Bahnschrift-normal", load: () => import("./Bahnschrift-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Bahnschrift-normal", load: () => import("./Bahnschrift-normal").then((module) => module.fontContent) },
  },
  "Baskerville": {
    normal: { modulePath: "./Baskerville-normal", load: () => import("./Baskerville-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Baskerville-normal", load: () => import("./Baskerville-normal").then((module) => module.fontContent) },
  },
  "Big Caslon": {
    normal: { modulePath: "./BigCaslon-normal", load: () => import("./BigCaslon-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./BigCaslon-normal", load: () => import("./BigCaslon-normal").then((module) => module.fontContent) },
  },
  "Bodoni 72": {
    normal: { modulePath: "./BodoniSvtyTwoITCTT-Book-normal", load: () => import("./BodoniSvtyTwoITCTT-Book-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./BodoniSvtyTwoITCTT-Book-normal", load: () => import("./BodoniSvtyTwoITCTT-Book-normal").then((module) => module.fontContent) },
  },
  "Bodoni 72 Oldstyle": {
    normal: { modulePath: "./BodoniSvtyTwoOSITCTT-Book-normal", load: () => import("./BodoniSvtyTwoOSITCTT-Book-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./BodoniSvtyTwoOSITCTT-Book-normal", load: () => import("./BodoniSvtyTwoOSITCTT-Book-normal").then((module) => module.fontContent) },
  },
  "Bodoni 72 Smallcaps": {
    normal: { modulePath: "./Bodoni-72-Smallcaps-Book-normal", load: () => import("./Bodoni-72-Smallcaps-Book-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Bodoni-72-Smallcaps-Book-normal", load: () => import("./Bodoni-72-Smallcaps-Book-normal").then((module) => module.fontContent) },
  },
  "Bradley Hand": {
    normal: { modulePath: "./Bradley-Hand-Bold-normal", load: () => import("./Bradley-Hand-Bold-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Bradley-Hand-Bold-normal", load: () => import("./Bradley-Hand-Bold-normal").then((module) => module.fontContent) },
  },
  "Brush Script MT": {
    normal: { modulePath: "./Brush-Script-normal", load: () => import("./Brush-Script-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Brush-Script-normal", load: () => import("./Brush-Script-normal").then((module) => module.fontContent) },
  },
  "Calibri": {
    normal: { modulePath: "./Calibri-normal", load: () => import("./Calibri-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Calibri-normal", load: () => import("./Calibri-normal").then((module) => module.fontContent) },
  },
  "Cambria": {
    normal: { modulePath: "./Cambria-normal", load: () => import("./Cambria-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Cambria-normal", load: () => import("./Cambria-normal").then((module) => module.fontContent) },
  },
  "Cambria Math": {
    normal: { modulePath: "./Cambria-Math-normal", load: () => import("./Cambria-Math-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Cambria-Math-normal", load: () => import("./Cambria-Math-normal").then((module) => module.fontContent) },
  },
  "Candara": {
    normal: { modulePath: "./Candara-normal", load: () => import("./Candara-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Candara-normal", load: () => import("./Candara-normal").then((module) => module.fontContent) },
  },
  "Chalkboard": {
    normal: { modulePath: "./Chalkboard-normal", load: () => import("./Chalkboard-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Chalkboard-normal", load: () => import("./Chalkboard-normal").then((module) => module.fontContent) },
  },
  "Chalkboard SE": {
    normal: { modulePath: "./ChalkboardSE-normal", load: () => import("./ChalkboardSE-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./ChalkboardSE-normal", load: () => import("./ChalkboardSE-normal").then((module) => module.fontContent) },
  },
  "Chalkduster": {
    normal: { modulePath: "./Chalkduster-normal", load: () => import("./Chalkduster-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Chalkduster-normal", load: () => import("./Chalkduster-normal").then((module) => module.fontContent) },
  },
  "Charter": {
    normal: { modulePath: "./Charter-Regular-normal", load: () => import("./Charter-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Charter-Regular-normal", load: () => import("./Charter-Regular-normal").then((module) => module.fontContent) },
  },
  "Cochin": {
    normal: { modulePath: "./Cochin-normal", load: () => import("./Cochin-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Cochin-normal", load: () => import("./Cochin-normal").then((module) => module.fontContent) },
  },
  "Comic Sans MS": {
    normal: { modulePath: "./Comic-Sans-MS-normal", load: () => import("./Comic-Sans-MS-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Comic-Sans-MS-normal", load: () => import("./Comic-Sans-MS-normal").then((module) => module.fontContent) },
  },
  "Consolas": {
    normal: { modulePath: "./Consolas-normal", load: () => import("./Consolas-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Consolas-normal", load: () => import("./Consolas-normal").then((module) => module.fontContent) },
  },
  "Constantia": {
    normal: { modulePath: "./Constantia-normal", load: () => import("./Constantia-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Constantia-normal", load: () => import("./Constantia-normal").then((module) => module.fontContent) },
  },
  "Copperplate": {
    normal: { modulePath: "./Copperplate-normal", load: () => import("./Copperplate-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Copperplate-normal", load: () => import("./Copperplate-normal").then((module) => module.fontContent) },
  },
  "Corbel": {
    normal: { modulePath: "./Corbel-normal", load: () => import("./Corbel-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Corbel-normal", load: () => import("./Corbel-normal").then((module) => module.fontContent) },
  },
  "Courier New": {
    normal: { modulePath: "./Courier-New-normal", load: () => import("./Courier-New-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Courier-New-normal", load: () => import("./Courier-New-normal").then((module) => module.fontContent) },
  },
  "DIN Alternate": {
    normal: { modulePath: "./DIN-Alternate-Bold-normal", load: () => import("./DIN-Alternate-Bold-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./DIN-Alternate-Bold-normal", load: () => import("./DIN-Alternate-Bold-normal").then((module) => module.fontContent) },
  },
  "DIN Condensed": {
    normal: { modulePath: "./DIN-Condensed-Bold-normal", load: () => import("./DIN-Condensed-Bold-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./DIN-Condensed-Bold-normal", load: () => import("./DIN-Condensed-Bold-normal").then((module) => module.fontContent) },
  },
  "Didot": {
    normal: { modulePath: "./Didot-normal", load: () => import("./Didot-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Didot-normal", load: () => import("./Didot-normal").then((module) => module.fontContent) },
  },
  "Ebrima": {
    normal: { modulePath: "./Ebrima-normal", load: () => import("./Ebrima-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Ebrima-normal", load: () => import("./Ebrima-normal").then((module) => module.fontContent) },
  },
  "Franklin Gothic Medium": {
    normal: { modulePath: "./Franklin-Gothic-Medium-normal", load: () => import("./Franklin-Gothic-Medium-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Franklin-Gothic-Medium-normal", load: () => import("./Franklin-Gothic-Medium-normal").then((module) => module.fontContent) },
  },
  "Futura": {
    normal: { modulePath: "./Futura-Medium-normal", load: () => import("./Futura-Medium-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Futura-Bold-normal", load: () => import("./Futura-Bold-normal").then((module) => module.fontContent) },
  },
  "Gabriola": {
    normal: { modulePath: "./Gabriola-normal", load: () => import("./Gabriola-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Gabriola-normal", load: () => import("./Gabriola-normal").then((module) => module.fontContent) },
  },
  "Gadugi": {
    normal: { modulePath: "./Gadugi-normal", load: () => import("./Gadugi-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Gadugi-normal", load: () => import("./Gadugi-normal").then((module) => module.fontContent) },
  },
  "Geneva": {
    normal: { modulePath: "./Geneva-normal", load: () => import("./Geneva-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Geneva-normal", load: () => import("./Geneva-normal").then((module) => module.fontContent) },
  },
  "Georgia": {
    normal: { modulePath: "./Georgia-normal", load: () => import("./Georgia-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Georgia-normal", load: () => import("./Georgia-normal").then((module) => module.fontContent) },
  },
  "Gill Sans": {
    normal: { modulePath: "./GillSans-normal", load: () => import("./GillSans-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./GillSans-Bold-bold", load: () => import("./GillSans-Bold-bold").then((module) => module.fontContent) },
  },
  "Helvetica": {
    normal: { modulePath: "./Helvetica-normal", load: () => import("./Helvetica-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Helvetica-Bold-normal", load: () => import("./Helvetica-Bold-normal").then((module) => module.fontContent) },
  },
  "Helvetica Neue": {
    normal: { modulePath: "./Helvetica-Neue-normal", load: () => import("./Helvetica-Neue-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Helvetica-Neue-Bold-normal", load: () => import("./Helvetica-Neue-Bold-normal").then((module) => module.fontContent) },
  },
  "Herculanum": {
    normal: { modulePath: "./Herculanum-normal", load: () => import("./Herculanum-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Herculanum-normal", load: () => import("./Herculanum-normal").then((module) => module.fontContent) },
  },
  "Hoefler Text": {
    normal: { modulePath: "./HoeflerText-Regular-normal", load: () => import("./HoeflerText-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./HoeflerText-Regular-normal", load: () => import("./HoeflerText-Regular-normal").then((module) => module.fontContent) },
  },
  "HoloLens MDL2 Assets": {
    normal: { modulePath: "./HoloLens-MDL2-Assets-normal", load: () => import("./HoloLens-MDL2-Assets-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./HoloLens-MDL2-Assets-normal", load: () => import("./HoloLens-MDL2-Assets-normal").then((module) => module.fontContent) },
  },
  "Impact": {
    normal: { modulePath: "./Impact-normal", load: () => import("./Impact-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Impact-normal", load: () => import("./Impact-normal").then((module) => module.fontContent) },
  },
  "Ink Free": {
    normal: { modulePath: "./Inkfree-normal", load: () => import("./Inkfree-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Inkfree-normal", load: () => import("./Inkfree-normal").then((module) => module.fontContent) },
  },
  "Javanese Text": {
    normal: { modulePath: "./Javanese-Text-normal", load: () => import("./Javanese-Text-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Javanese-Text-normal", load: () => import("./Javanese-Text-normal").then((module) => module.fontContent) },
  },
  "Leelawadee UI": {
    normal: { modulePath: "./Leelawadee-UI-normal", load: () => import("./Leelawadee-UI-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Leelawadee-UI-normal", load: () => import("./Leelawadee-UI-normal").then((module) => module.fontContent) },
  },
  "Lucida Console": {
    normal: { modulePath: "./Lucida-Console-Regular-normal", load: () => import("./Lucida-Console-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Lucida-Console-Regular-normal", load: () => import("./Lucida-Console-Regular-normal").then((module) => module.fontContent) },
  },
  "Lucida Grande": {
    normal: { modulePath: "./Lucida-Grande-normal", load: () => import("./Lucida-Grande-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Lucida-Grande-normal", load: () => import("./Lucida-Grande-normal").then((module) => module.fontContent) },
  },
  "Lucida Sans Unicode": {
    normal: { modulePath: "./Lucida-Sans-Unicode-Regular-normal", load: () => import("./Lucida-Sans-Unicode-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Lucida-Sans-Unicode-Regular-normal", load: () => import("./Lucida-Sans-Unicode-Regular-normal").then((module) => module.fontContent) },
  },
  "Luminari": {
    normal: { modulePath: "./Luminari-normal", load: () => import("./Luminari-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Luminari-normal", load: () => import("./Luminari-normal").then((module) => module.fontContent) },
  },
  "MS Gothic": {
    normal: { modulePath: "./MS-Gothic-normal", load: () => import("./MS-Gothic-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./MS-Gothic-normal", load: () => import("./MS-Gothic-normal").then((module) => module.fontContent) },
  },
  "MV Boli": {
    normal: { modulePath: "./MV-Boli-normal", load: () => import("./MV-Boli-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./MV-Boli-normal", load: () => import("./MV-Boli-normal").then((module) => module.fontContent) },
  },
  "Malgun Gothic": {
    normal: { modulePath: "./Malgun-Gothic-normal", load: () => import("./Malgun-Gothic-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Malgun-Gothic-normal", load: () => import("./Malgun-Gothic-normal").then((module) => module.fontContent) },
  },
  "Marker Felt": {
    normal: { modulePath: "./MarkerFelt-Thin-normal", load: () => import("./MarkerFelt-Thin-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./MarkerFelt-Thin-normal", load: () => import("./MarkerFelt-Thin-normal").then((module) => module.fontContent) },
  },
  "Marlett": {
    normal: { modulePath: "./Marlett-normal", load: () => import("./Marlett-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Marlett-normal", load: () => import("./Marlett-normal").then((module) => module.fontContent) },
  },
  "Menlo": {
    normal: { modulePath: "./Menlo-Regular-normal", load: () => import("./Menlo-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Menlo-Regular-normal", load: () => import("./Menlo-Regular-normal").then((module) => module.fontContent) },
  },
  "Microsoft Himalaya": {
    normal: { modulePath: "./Microsoft-Himalaya-normal", load: () => import("./Microsoft-Himalaya-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-Himalaya-normal", load: () => import("./Microsoft-Himalaya-normal").then((module) => module.fontContent) },
  },
  "Microsoft JhengHei": {
    normal: { modulePath: "./Microsoft-JhengHei-normal", load: () => import("./Microsoft-JhengHei-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-JhengHei-normal", load: () => import("./Microsoft-JhengHei-normal").then((module) => module.fontContent) },
  },
  "Microsoft New Tai Lue": {
    normal: { modulePath: "./Microsoft-New-Tai-Lue-normal", load: () => import("./Microsoft-New-Tai-Lue-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-New-Tai-Lue-normal", load: () => import("./Microsoft-New-Tai-Lue-normal").then((module) => module.fontContent) },
  },
  "Microsoft PhagsPa": {
    normal: { modulePath: "./Microsoft-PhagsPa-normal", load: () => import("./Microsoft-PhagsPa-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-PhagsPa-normal", load: () => import("./Microsoft-PhagsPa-normal").then((module) => module.fontContent) },
  },
  "Microsoft Sans Serif": {
    normal: { modulePath: "./Microsoft-Sans-Serif-normal", load: () => import("./Microsoft-Sans-Serif-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-Sans-Serif-normal", load: () => import("./Microsoft-Sans-Serif-normal").then((module) => module.fontContent) },
  },
  "Microsoft Tai Le": {
    normal: { modulePath: "./Microsoft-Tai-Le-normal", load: () => import("./Microsoft-Tai-Le-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-Tai-Le-normal", load: () => import("./Microsoft-Tai-Le-normal").then((module) => module.fontContent) },
  },
  "Microsoft YaHei": {
    normal: { modulePath: "./Microsoft-Yahei-normal", load: () => import("./Microsoft-Yahei-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-Yahei-normal", load: () => import("./Microsoft-Yahei-normal").then((module) => module.fontContent) },
  },
  "Microsoft Yi Baiti": {
    normal: { modulePath: "./Microsoft-Yi-Baiti-normal", load: () => import("./Microsoft-Yi-Baiti-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Microsoft-Yi-Baiti-normal", load: () => import("./Microsoft-Yi-Baiti-normal").then((module) => module.fontContent) },
  },
  "MingLiU-ExtB": {
    normal: { modulePath: "./MingLiU-ExtB-normal", load: () => import("./MingLiU-ExtB-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./MingLiU-ExtB-normal", load: () => import("./MingLiU-ExtB-normal").then((module) => module.fontContent) },
  },
  "Monaco": {
    normal: { modulePath: "./Monaco-normal", load: () => import("./Monaco-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Monaco-normal", load: () => import("./Monaco-normal").then((module) => module.fontContent) },
  },
  "Mongolian Baiti": {
    normal: { modulePath: "./Mongolian-Baiti-normal", load: () => import("./Mongolian-Baiti-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Mongolian-Baiti-normal", load: () => import("./Mongolian-Baiti-normal").then((module) => module.fontContent) },
  },
  "Myanmar Text": {
    normal: { modulePath: "./Myanmar-Text-normal", load: () => import("./Myanmar-Text-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Myanmar-Text-normal", load: () => import("./Myanmar-Text-normal").then((module) => module.fontContent) },
  },
  "Nirmala UI": {
    normal: { modulePath: "./Nirmala-normal", load: () => import("./Nirmala-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Nirmala-normal", load: () => import("./Nirmala-normal").then((module) => module.fontContent) },
  },
  "Noteworthy": {
    normal: { modulePath: "./Noteworthy-Light-normal", load: () => import("./Noteworthy-Light-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Noteworthy-Light-normal", load: () => import("./Noteworthy-Light-normal").then((module) => module.fontContent) },
  },
  "Optima": {
    normal: { modulePath: "./Optima-Regular-normal", load: () => import("./Optima-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Optima-Regular-normal", load: () => import("./Optima-Regular-normal").then((module) => module.fontContent) },
  },
  "Palatino": {
    normal: { modulePath: "./Palatino-Roman-normal", load: () => import("./Palatino-Roman-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Palatino-Roman-normal", load: () => import("./Palatino-Roman-normal").then((module) => module.fontContent) },
  },
  "Palatino Linotype": {
    normal: { modulePath: "./Palatino-Linotype-normal", load: () => import("./Palatino-Linotype-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Palatino-Linotype-normal", load: () => import("./Palatino-Linotype-normal").then((module) => module.fontContent) },
  },
  "Papyrus": {
    normal: { modulePath: "./Papyrus-normal", load: () => import("./Papyrus-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Papyrus-normal", load: () => import("./Papyrus-normal").then((module) => module.fontContent) },
  },
  "Phosphate": {
    normal: { modulePath: "./Phosphate-Inline-normal", load: () => import("./Phosphate-Inline-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Phosphate-Inline-normal", load: () => import("./Phosphate-Inline-normal").then((module) => module.fontContent) },
  },
  "Rockwell": {
    normal: { modulePath: "./Rockwell-Regular-normal", load: () => import("./Rockwell-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Rockwell-Bold-normal", load: () => import("./Rockwell-Bold-normal").then((module) => module.fontContent) },
  },
  "Savoye LET": {
    normal: { modulePath: "./SavoyeLetPlain-normal", load: () => import("./SavoyeLetPlain-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./SavoyeLetPlain-normal", load: () => import("./SavoyeLetPlain-normal").then((module) => module.fontContent) },
  },
  "Segoe MDL2 Assets": {
    normal: { modulePath: "./Segoe-MDL2-Assets-normal", load: () => import("./Segoe-MDL2-Assets-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Segoe-MDL2-Assets-normal", load: () => import("./Segoe-MDL2-Assets-normal").then((module) => module.fontContent) },
  },
  "Segoe Print": {
    normal: { modulePath: "./Segoe-Print-normal", load: () => import("./Segoe-Print-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Segoe-Print-normal", load: () => import("./Segoe-Print-normal").then((module) => module.fontContent) },
  },
  "Segoe Script": {
    normal: { modulePath: "./Segoe-Script-normal", load: () => import("./Segoe-Script-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Segoe-Script-normal", load: () => import("./Segoe-Script-normal").then((module) => module.fontContent) },
  },
  "Segoe UI": {
    normal: { modulePath: "./Segoe-UI-normal", load: () => import("./Segoe-UI-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Segoe-UI-bold-bold", load: () => import("./Segoe-UI-bold-bold").then((module) => module.fontContent) },
  },
  "SignPainter": {
    normal: { modulePath: "./SignPainter-normal", load: () => import("./SignPainter-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./SignPainter-normal", load: () => import("./SignPainter-normal").then((module) => module.fontContent) },
  },
  "SimSun": {
    normal: { modulePath: "./SimSun-normal", load: () => import("./SimSun-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./SimSun-normal-bold", load: () => import("./SimSun-normal-bold").then((module) => module.fontContent) },
  },
  "Sitka": {
    normal: { modulePath: "./Sitka-normal", load: () => import("./Sitka-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Sitka-normal", load: () => import("./Sitka-normal").then((module) => module.fontContent) },
  },
  "Skia": {
    normal: { modulePath: "./Skia-normal", load: () => import("./Skia-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Skia-normal", load: () => import("./Skia-normal").then((module) => module.fontContent) },
  },
  "Snell Roundhand": {
    normal: { modulePath: "./SnellRoundhand-normal", load: () => import("./SnellRoundhand-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./SnellRoundhand-normal", load: () => import("./SnellRoundhand-normal").then((module) => module.fontContent) },
  },
  "Sylfaen": {
    normal: { modulePath: "./Sylfaen-Regular-normal", load: () => import("./Sylfaen-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Sylfaen-Regular-normal", load: () => import("./Sylfaen-Regular-normal").then((module) => module.fontContent) },
  },
  "Symbol": {
    normal: { modulePath: "./Symbol-normal", load: () => import("./Symbol-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Symbol-normal", load: () => import("./Symbol-normal").then((module) => module.fontContent) },
  },
  "Tahoma": {
    normal: { modulePath: "./Tahoma-normal", load: () => import("./Tahoma-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Tahoma-Bold-bold", load: () => import("./Tahoma-Bold-bold").then((module) => module.fontContent) },
  },
  "Times": {
    normal: { modulePath: "./Times-Roman-normal", load: () => import("./Times-Roman-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Times-Bold-bold", load: () => import("./Times-Bold-bold").then((module) => module.fontContent) },
  },
  "Times New Roman": {
    normal: { modulePath: "./Times-New-Roman-normal", load: () => import("./Times-New-Roman-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Times-New-Roman-Bold-bold", load: () => import("./Times-New-Roman-Bold-bold").then((module) => module.fontContent) },
  },
  "Trattatello": {
    normal: { modulePath: "./Trattatello-normal", load: () => import("./Trattatello-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Trattatello-normal", load: () => import("./Trattatello-normal").then((module) => module.fontContent) },
  },
  "Trebuchet MS": {
    normal: { modulePath: "./Trebuchet-MS-normal", load: () => import("./Trebuchet-MS-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Trebuchet-MS-Bold-bold", load: () => import("./Trebuchet-MS-Bold-bold").then((module) => module.fontContent) },
  },
  "Verdana": {
    normal: { modulePath: "./Verdana-normal", load: () => import("./Verdana-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Verdana-normal", load: () => import("./Verdana-normal").then((module) => module.fontContent) },
  },
  "Yu Gothic": {
    normal: { modulePath: "./YuGothic-Regular-normal", load: () => import("./YuGothic-Regular-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./YuGothic-Bold-bold", load: () => import("./YuGothic-Bold-bold").then((module) => module.fontContent) },
  },
  "Zapfino": {
    normal: { modulePath: "./Zapfino-normal", load: () => import("./Zapfino-normal").then((module) => module.fontContent) },
    bold: { modulePath: "./Zapfino-normal", load: () => import("./Zapfino-normal").then((module) => module.fontContent) },
  },
};
